export default __webpack_public_path__ + "static/media/gauntlets_of_the_defiant.8271ac43.jpg";